<template>
	<div @click.stop="onClick">
		<EditableTextField
			ref="name"
			isEditOnClick
			:text="textLocal"
			@blur="saveAndBlur"
			@onSave="saveAndBlur"
			@click.native.stop="onClick"
			@keydown.enter="saveAndBlur"
			@keydown.escape="saveAndBlur"
			:disabled="!hasEditPermissions"
			:isEditing.sync="localIsEditing"
			placeholder="Version description"
			class="editable-text-field text-overflow-ellipsis"
		>
			<template v-slot:append>
				<AnemicButton @click.native.stop="onClick" class="pa-0 edit-button mt-1" x-small fab rounded>
					<v-icon size="12" color="#6B7786">mdi-pencil</v-icon>
				</AnemicButton>
			</template>
		</EditableTextField>
	</div>
</template>

<script>
import EditableTextField from '@/components/common/EditableTextField';
export default {
	name: 'WorkflowVersionEditableDescription',
	components: {
		EditableTextField,
	},
	props: {
		text: { type: String },
		isEditing: { type: Boolean },
		hasChevron: { type: Boolean },
		placeholder: { type: String },
		hasEditPermissions: { type: Boolean },
		isEditOnClick: { type: Boolean, default: false },
	},
	computed: {
		localIsEditing: {
			get() {
				return this.isEditing;
			},
			set(newV) {
				this.$emit('update:isEditing', newV);
			},
		},
	},
	methods: {
		onDelete() {
			this.$refs.name.onDelete();
		},
		saveAndBlur(newText) {
			this.$refs.name.blur();
			this.saveName(newText);
		},

		saveName(newText) {
			this.$emit('onSave', newText);
			this.localIsEditing = false;
		},
		onClick(e) {
			this.$emit('select-version', e);
			this.localIsEditing = true;
			e.preventDefault();
			e.stopPropagation();
		},
	},
	watch: {
		text: {
			handler(newV) {
				if (newV) {
					this.textLocal = newV;
				}
			},
			immediate: true,
			deep: true,
		},
	},
	data() {
		return {
			textLocal: '',
		};
	},
};
</script>

<style scoped lang="scss">
.editable-text-field {
	&::v-deep {
		&.v-text-field {
			color: black !important;
			font-size: 11px !important;
			font-weight: 300 !important;
			> .v-input__control > .v-input__slot {
				&:before {
					border-color: rgba(0, 0, 0, 0.42);
					border: none;
				}
				&:hover {
					border-bottom: 1px dashed grey !important;
				}

				&:after {
					border-width: 1px !important;
				}
			}

			&.v-input--is-disabled,
			&.v-input--is-disabled input {
				color: #3e495a !important;
				opacity: 1 !important;
			}
		}
	}
}

.edit-button {
	width: 16px;
	height: 16px;
}
</style>
